export const constants = {
  configuration: 'configuration',
  notification: 'notification',
  settings: 'settings',
  status: 'status',
  user: 'user',
};

/**
 * Error categories surfaced to the user. NETWORK means the request never reached
 * the backend at all, which is a different failure from the device not answering
 * - the latter has its own "device not responding" banner.
 */
export const ERROR_TYPES = {
  NETWORK: 'Network',
  PLANT_ID: 'plant_id',
  REGISTERED: 'registered',
  EXISTING_ANOTHER_PLANT: 'Existing',
  ERROR: '401',
};
